export default __webpack_public_path__ + "static/media/golf-vista-homes.670df5e1.jpg";